var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{class:['term','term' + _vm.line.type]},[_vm._v(_vm._s(_vm.line.type == 'input' ? 'hub> ' : '')+_vm._s(_vm.line.cmd))])}
var staticRenderFns = []

export { render, staticRenderFns }